var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthleticAbilityIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.99998C2 7.82317 2.07024 7.6536 2.19526 7.52858C2.32029 7.40355 2.48986 7.33331 2.66667 7.33331H13.3333C13.5101 7.33331 13.6797 7.40355 13.8047 7.52858C13.9298 7.6536 14 7.82317 14 7.99998C14 8.17679 13.9298 8.34636 13.8047 8.47138C13.6797 8.59641 13.5101 8.66665 13.3333 8.66665H2.66667C2.48986 8.66665 2.32029 8.59641 2.19526 8.47138C2.07024 8.34636 2 8.17679 2 7.99998Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleticAbilityIcon4);
export default __webpack_public_path__ + "static/media/AthleticAbilityIcon_4.db94caed534a1ffa0cb0abde045f58bd.svg";
export { ForwardRef as ReactComponent };